import dayjs from 'dayjs';
import { useCallback, useMemo } from 'react';
import { BooleanParam, useQueryParam, withDefault } from 'use-query-params';
import { comparisonDateRangeOptions } from './consts';
export const useCompareDateRangeParams = (dateRange) => {
    const [comparisonParam, setComparisonParam] = useQueryParam('compare', withDefault(BooleanParam, undefined));
    const options = useMemo(() => {
        // Check if dateRange has dates
        if (!dateRange.dates || dateRange.dates.length < 2) {
            // Fallback to default dates if dateRange is missing
            const previousPeriodOption = {
                label: 'Previous period',
                value: true,
                dates: [dayjs().subtract(7, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()],
            };
            return [previousPeriodOption, ...comparisonDateRangeOptions];
        }
        const [startDate, endDate] = dateRange.dates;
        const startDayjs = dayjs(startDate);
        const endDayjs = dayjs(endDate);
        // Calculate the difference in days between dates
        const daysDifference = endDayjs.diff(startDayjs, 'day');
        // Check if the range is less than 1 month (30 days)
        const isLessThanOneMonth = daysDifference < 30;
        let compareStartDate;
        let compareEndDate;
        if (isLessThanOneMonth) {
            // If range < 1 month: same range in the previous month of the same year
            const monthDifference = endDayjs.diff(startDayjs, 'month');
            if (monthDifference === 0) {
                // If dates are in the same month, take the previous month
                compareStartDate = startDayjs.subtract(1, 'month');
                compareEndDate = endDayjs.subtract(1, 'month');
            }
            else {
                // If dates span different months, take the previous period of the same year
                compareStartDate = startDayjs.subtract(1, 'month');
                compareEndDate = endDayjs.subtract(1, 'month');
            }
        }
        else {
            // If range >= 1 month: same period in the previous year
            compareStartDate = startDayjs.subtract(1, 'year');
            compareEndDate = endDayjs.subtract(1, 'year');
        }
        const previousPeriodOption = {
            label: 'Previous period',
            value: true,
            dates: [compareStartDate.toDate(), compareEndDate.toDate()],
        };
        return [previousPeriodOption, ...comparisonDateRangeOptions];
    }, [dateRange]);
    const compareDateRange = useMemo(() => {
        return options.find((option) => option.value === comparisonParam) || options[0];
    }, [comparisonParam, options]);
    const setCompareDateRange = useCallback((newCompareDateRange) => {
        setComparisonParam(newCompareDateRange.value);
    }, [setComparisonParam]);
    return {
        options,
        compareDateRange,
        setCompareDateRange,
    };
};
